import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/login/callback')({
  errorComponent: ({ error }) => <p>{error.message}</p>,
  loader: async ({ context }) => {
    const { authClient } = context;

    if (await authClient.isAuthenticated()) {
      throw redirect({ to: '/' });
    }

    if (authClient.isLoginRedirect()) {
      await authClient.handleRedirect();
    }
  },
});
